// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ActionSheet_card__1VV8o {\n  margin: 5px 0px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.ActionSheet_hidden__3wah1 {\n  height: 34px;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Action/ActionSheet.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,YAAY;AACd","sourcesContent":[".card {\n  margin: 5px 0px;\n  color: rgba(0, 0, 0, 0.54);\n}\n.hidden {\n  height: 34px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "ActionSheet_card__1VV8o",
	"hidden": "ActionSheet_hidden__3wah1"
};
export default ___CSS_LOADER_EXPORT___;
